export const BUTTON_HEIGHT_MAP = {
    l: 60,
    m: 48,
    s: 40,
    xs: 32,
    xxs: 24,
    h20: 20,
    h24: 24,
    h28: 28,
    h32: 32,
    h36: 36,
    h40: 40,
};
export const BUTTON_PADDING_MAP = {
    l: 64,
    m: 32,
    s: 24,
    xs: 12,
    xxs: 10,
    h20: 8,
    h24: 8,
    h28: 12,
    h32: 12,
    h36: 12,
    h40: 12,
};
export const LOADER_SIZE_MAP = {
    l: 18,
    m: 16,
    s: 16,
    xs: 16,
    xxs: 16,
    h20: 12,
    h24: 16,
    h28: 16,
    h32: 16,
    h36: 16,
    h40: 18,
};
export const ICON_SIZE_MAP = {
    l: 24,
    m: 20,
    s: 18,
    xs: 16,
    xxs: 16,
    h20: 12,
    h24: 16,
    h28: 16,
    h32: 16,
    h36: 16,
    h40: 18,
};
export const BUTTON_FONT_SIZE_MAP = {
    l: 20,
    m: 14,
    s: 12,
    xs: 12,
    xxs: 12,
    h20: 10,
    h24: 12,
    h28: 12,
    h32: 12,
    h36: 12,
    h40: 12,
};
export const BUTTON_RADIUS_MAP_ROUNDED = {
    l: 12,
    m: 8,
    s: 8,
    xs: 8,
    xxs: 6,
    h20: 6,
    h24: 6,
    h28: 8,
    h32: 8,
    h36: 8,
    h40: 8,
};
//# sourceMappingURL=constants.js.map